import React from 'react';

import { LoginForm } from './components/LoginFrom/LoginForm';
import { Chatterbox } from 'components/modules/Widgets/External/Chatterbox';

import * as S from './AuthPage.styles';

export const AuthPage = () => {
  return (
    <S.Container>
      <LoginForm />
      <Chatterbox />
    </S.Container>
  );
};
